// utils/camposCambiados.ts — enviar al servidor SOLO lo que la persona cambió (round 2026-10-30).
//
// Un modal de edición se abre con una foto de la fila. Si otra persona cambia un dato mientras tanto (el teléfono, por ejemplo)
// y este formulario reenvía TODOS sus campos al guardar, pisa el cambio ajeno con el valor viejo de la foto aunque la persona
// solo haya tocado el nombre. Mandando solo los campos que cambiaron respecto de esa foto, lo que no se tocó no se escribe.

/** Un valor como texto comparable: null/undefined = "", los textos sin espacios en las puntas, los arreglos ordenados. */
export function comoTextoComparable(valor: unknown): string {
  if (Array.isArray(valor)) return JSON.stringify(valor.map((v) => String(v).trim()).sort());
  if (valor === null || valor === undefined) return "";
  return String(valor).trim();
}

/** ¿Cambió el valor respecto del original? */
export const cambio = (original: unknown, nuevo: unknown): boolean =>
  comoTextoComparable(original) !== comoTextoComparable(nuevo);

/**
 * Las claves (de `claves`) cuyo valor del formulario cambió respecto del original. Un campo que el formulario no tiene
 * (`undefined`: no está montado, p. ej. los datos bancarios de quien no es aseador) nunca cuenta como cambio.
 */
export function clavesCambiadas<K extends string>(
  original: Record<string, unknown> | null | undefined,
  nuevo: Record<string, unknown> | null | undefined,
  claves: readonly K[],
): K[] {
  return claves.filter((k) => nuevo?.[k] !== undefined && cambio(original?.[k], nuevo?.[k]));
}
